import React from "react";
import { connect } from "react-redux";
import { setUserCredential, setUserProfile } from '@app/state/actions';
import { injectIntl } from "react-intl";
// nodejs library that concatenates classes
import classNames from "classnames";
// path constants
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
// core components
import CustomHeader from "@app/components/Header/CustomHeader";
import GridContainer from "@app/components/Grid/GridContainer";
import GridItem from "@app/components/Grid/GridItem";
import CustomHelmet from "@app/components/CustomHelmets/CustomHelmet";
// Sections
import LandingIntro from "./Sections/LandingIntro";
import Options from "./Sections/Options";
import Features from "./Sections/Features";
import StatsBanner from "./Sections/StatsBanner";
import SignUpBanner from "./Sections/SignUpBanner";
import Partners from "./Sections/Partners";
import SectionCurrent from "@app/views/Blog/BlogIndex/Sections/SectionCurrent";
import SectionPricingShorter from "@app/views/PricingPages/Sections/SectionPricingShorter";
import Promos from "./Sections/Promos";
 
// styles
import landingPageStyle from "@app/assets/jss/material-kit-pro-react/views/landingPageStyle";
class LandingPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            openConsumerModal: false,
            openProviderModal: false,
        };

        this.handleOpenModal = this.handleOpenModal.bind(this);
        this.handleCloseModal = this.handleCloseModal.bind(this);
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        document.body.scrollTop = 0;
    }

    handleOpenModal(modalType) {
        this.setState({
            [modalType]: true
        });
    }

    handleCloseModal(modalType) {
        this.setState({
            [modalType]: false
        });
    }
    
    render() {
        const { classes } = this.props;
        // Locale and Lang

        const ogLocale = this.props.intl.formatMessage({ id: "og.locale" });
        const ogLocaleAlt1 = this.props.intl.formatMessage({ id: "og.localeAlt1" });
        const ogLocaleAlt2 = this.props.intl.formatMessage({ id: "og.localeAlt2" });
        
        const appName = this.props.intl.formatMessage({ id: "app.name" });
        const ogTitle = this.props.intl.formatMessage({ id: "landing.og.title" });
        const ogDescription = this.props.intl.formatMessage({ id: "landing.og.description" });
        const ogImage = this.props.intl.formatMessage({ id: "landing.og.image" });
        const ogImageType = this.props.intl.formatMessage({ id: "landing.og.image.type" });
        const ogImageWidth = Number(this.props.intl.formatMessage({ id: "landing.og.image.width" }));
        const ogImageHeight = Number(this.props.intl.formatMessage({ id: "landing.og.image.height" }));
        const ogImageAlt = this.props.intl.formatMessage({ id: "landing.og.image.alt" });
        const twitterCardType = this.props.intl.formatMessage({ id: "meta.twitterCardType" });
        const twitterCreator = this.props.intl.formatMessage({ id: "meta.twitterCreator" });
        const twitterDescription = this.props.intl.formatMessage({ id: "meta.twitterDescription" });
        const twitterTitle = this.props.intl.formatMessage({ id: "meta.twitterTitle" });
        const twitterImage = this.props.intl.formatMessage({ id: "meta.twitterImage" });
        const twitterImageAlt = this.props.intl.formatMessage({ id: "meta.twitterImageAlt" });


        const readBlogCallToAction = this.props.intl.formatMessage({ id: "check.out.latest.blog.posts" });

        const mainNonLogged = (
            <div className={classNames(classes.main, classes.mainRaised)}>
                <div className={classes.container}>
                    <GridContainer>
                        <GridItem
                                xs={12}
                                className={
                                    classes.mlAuto + " " + classes.mrAuto + " " + classes.textCenter
                                }
                            >
                            <Features/>
                        </GridItem>
                        <GridItem
                                xs={12}
                                className={
                                    classes.mlAuto + " " + classes.mrAuto + " " + classes.textCenter
                                }
                            >
                            <StatsBanner/>
                        </GridItem>
                        <GridItem
                            xs={12}
                            className={
                                classes.mlAuto + " " + classes.mrAuto + " " + classes.textCenter
                            }
                        >
                            <h2 className={classes.titleDark}>
                                Our Technology Partners
                            </h2>
                            <Partners/>
                        </GridItem>
                    </GridContainer>
                    <SectionCurrent
                        width={6}
                        sectionTitle={readBlogCallToAction}
                    />
                </div>
            </div>
        );

        const mainLogged = (
            <div className={classNames(classes.main, classes.mainRaised)}>
                <div className={classes.container}>
                    <Options/>
                    <SectionCurrent
                        width={6}
                        sectionTitle={readBlogCallToAction}
                    />
                </div>
            </div>
        );

        const main = this.props.userProfile ? mainLogged : mainNonLogged;

        return (
            <div>
                <CustomHelmet
                    htmlLang={ogLocale}
                    helmetTitle={ogTitle}
                    metaDescription={ogDescription}
                    ogTitle={ogTitle}
                    ogDescription={ogDescription}
                    ogLocale={ogLocale}
                    ogLocaleAlt1={ogLocaleAlt1}
                    ogLocaleAlt2={ogLocaleAlt2}
                    ogImage={ogImage}
                    ogImageType={ogImageType}
                    ogImageWidth={ogImageWidth}
                    ogImageHeight={ogImageHeight}
                    ogImageAlt={ogImageAlt}
                    twitterTitle={twitterTitle}
                    twitterDescription={twitterDescription}
                    twitterCardType={twitterCardType}
                    twitterCreator={twitterCreator}
                    twitterImage={twitterImage}
                    twitterImageAlt={twitterImageAlt}
                />
                <CustomHeader
                    brandName={appName}
                    headerColor="white"
                />
                <div className={classes.main}>
                    {this.props.userProfile ?  '' : <LandingIntro/>}
                    {this.props.userProfile ?  '' : <Features/>}
                    {this.props.userProfile ?  '' : <StatsBanner/>}
                    {this.props.userProfile ?  '' : <SectionPricingShorter/>}
                    {this.props.userProfile ?  '' : <SignUpBanner/>}
                    {this.props.userProfile ?  '' : <Promos/>}
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        locale: state.i18n.locale,
        userProfile: state.authentication.userProfile
    }
}

const mapDispatchToProps = dispatch => {
    return {
        setUserCredential: userCredential => dispatch(setUserCredential(userCredential)),
        setUserProfile: userProfile => dispatch(setUserProfile(userProfile)),
        setLocale: locale => dispatch(setLocale(locale))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(withStyles(landingPageStyle)(LandingPage)));